import React, { useEffect, useState } from "react";
import { ArrowLeftOutlined, UserOutlined } from "@ant-design/icons";
import { Card, Flex, Select, DatePicker, Row, Col, Form, Button, Typography } from "antd";
import { EnquiryService } from "../../../Services/Manage/EnquiryService";
import { UserService } from "../../../Services/Manage/UserService";
import useMessage from "antd/es/message/useMessage";
import ListEqData from "./ListEqData";
import AddQuotationData from "./AddQuotationData";
import { QuotationService } from "../../../Services/Manage/QuotationService";
import dayjs from "dayjs";
import DropdownBtn from "../../general/DropdownBtn";

const { Option, OptGroup } = Select;

const CreateQuotation = () => {
    const [data, setData] = useState([]);
    const [message, msgConxt] = useMessage();
    const [eqData, setEqData] = useState([]);
    const [qu_gen, setQu_gen] = useState([]);
    const [Eqslected, seEQSelect] = useState(true);
    const [selectedDate, setSelectedDate] = useState('');
    const [followDate, setFollowDate] = useState('');

    const [customerForm] = Form.useForm();

    const getAllCompletedEnquiry = async () => {
        try {
            const user = await UserService.getOmeUser();
            const request = await EnquiryService.getAllActiveEnquiriesById(user.uid);

            setData(request.data);

            const newQuNumber = await handleGenerateQu();
            setQu_gen(newQuNumber);

        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getAllCompletedEnquiry();
    }, []);

    const Title = ({ title }) => (
        <Flex align="center" justify="space-between">
            {title}
        </Flex>
    );

    const renderItem = (eqId, name) => (
        <Flex align="center" justify="space-between" style={{ width: "100%" }}>
            <span>{eqId}</span>
            <span>
                <UserOutlined /> {name}
            </span>
        </Flex>
    );

    const grouped = data.reduce((acc, item) => {
        if (!acc[item.service_id]) {
            acc[item.service_id] = {
                service_name: item.service_name,
                items: [],
            };
        }
        acc[item.service_id].items.push(item);
        return acc;
    }, {});


    const handleGetCustomerData = (data) => {

        const payload = {
            ...data,
            n_follow_up: data.n_follow_up
                ? data.n_follow_up.format("DD-MM-YYYY")
                : null,
        };
        // setCustomerData(payload);
        console.log("customer data", payload);

    }

    const handleGetDatabyEqid = async (value, option) => {
        console.log("handleGetDatabyEqid", handleGetDatabyEqid);

        try {
            const request = await EnquiryService.getEnquiryDetailsById(value);

            if (request.status) {
                message.success(request.message);
                setEqData(request.data);
                seEQSelect(true);

            } else {
                message.error(request.message);
            }

        } catch (error) {
            console.error(error);
        }
    };



    const handleGenerateQu = async () => {
        try {
            const request = await QuotationService.getAllQuotationLast();
            console.log('Last quotation:', request);

            // Get current date components
            const now = new Date();
            const currentMonth = String(now.getMonth() + 1).padStart(2, '0'); // MM
            const currentYear = String(now.getFullYear()).slice(-2); // YY

            let newQuNumber = `${currentMonth}${currentYear}-0001`; // default

            // Ensure we have last quotation data
            if (request?.data && request.data.qu_no) {
                const lastQuNo = request.data.qu_no;

                // Expecting format: MMYY-XXXX
                const [monthYearPart, sequencePart] = lastQuNo.split('-');

                if (monthYearPart && sequencePart) {
                    const lastMonth = monthYearPart.slice(0, 2);
                    const lastYear = monthYearPart.slice(2);

                    if (lastMonth === currentMonth && lastYear === currentYear) {
                        const sequenceNum = parseInt(sequencePart, 10);
                        const newSequence = String(sequenceNum + 1).padStart(4, '0');
                        newQuNumber = `${currentMonth}${currentYear}-${newSequence}`;
                    }
                }
            }

            console.log('New quotation number:', newQuNumber);
            setQu_gen(newQuNumber);
            return newQuNumber;

        } catch (error) {
            console.error('Error generating quotation number:', error);

            // Fallback
            const now = new Date();
            const currentMonth = String(now.getMonth() + 1).padStart(2, '0');
            const currentYear = String(now.getFullYear()).slice(-2);
            const fallbackQuNo = `${currentMonth}${currentYear}-0001`;
            console.log('Fallback quotation number:', fallbackQuNo);
            return fallbackQuNo;
        }
    };


    return (
        <>
            {msgConxt}
            <Card size="large"
                title={

                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <ArrowLeftOutlined
                            style={{ cursor: "pointer", fontSize: "20px" }}
                            onClick={() => window.history.back()}
                        />
                        <Typography.Title level={4} style={{ margin: 0 }}>
                            Create Quotation
                        </Typography.Title>
                    </div>
                }
                extra={
                    <DropdownBtn />
                }
            >
                <Form layout="vertical">
                    <Row gutter={[24, 16]}>
                        <Col xs={24} sm={8} md={8} lg={8}>
                            <Form.Item label="Quotation Date" name="quotationDate">
                                <DatePicker
                                    style={{ width: "100%" }}
                                    size="large"
                                    format="DD-MM-YYYY"
                                    onChange={(date) => {
                                        if (date) {
                                            const formattedForDB = dayjs(date).format("YYYY-MM-DD");
                                            console.log("Send this to DB:", formattedForDB);

                                            setSelectedDate(formattedForDB);
                                        } else {
                                            setSelectedDate(null);
                                        }
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={8} md={8} lg={8}>
                            <Form.Item label="Select Enquiry" name="enquiry">
                                <Select
                                    showSearch
                                    allowClear
                                    onClear={() => {
                                        seEQSelect(false)
                                        setEqData(null)
                                    }
                                    }
                                    style={{ width: "100%" }}
                                    placeholder="Select approved enquiry"
                                    size="large"
                                    onChange={(value, option) => handleGetDatabyEqid(value, option)}
                                    filterOption={(input, option) => {
                                        const serviceName = option?.service_name?.toLowerCase() ?? "";
                                        const eqId = option?.eq_id?.toLowerCase() ?? "";
                                        const name = option?.name?.toLowerCase() ?? "";
                                        const search = input.toLowerCase();
                                        return (
                                            serviceName.includes(search) ||
                                            eqId.includes(search) ||
                                            name.includes(search)
                                        );
                                    }}
                                >
                                    {Object.values(grouped).map((group) => (
                                        <OptGroup
                                            key={group.service_name}
                                            label={<Title title={group.service_name} />}
                                        >
                                            {group.items.map((item) => (
                                                <Option
                                                    key={item.eq_id}
                                                    value={item.eq_id}
                                                    service_name={group.service_name}
                                                    eq_id={item.eq_id}
                                                    name={item.name}
                                                >
                                                    {renderItem(item.eq_id, item.name)}
                                                </Option>
                                            ))}
                                        </OptGroup>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={8} md={8} lg={8}>
                            <Form.Item layout="vertical" name="n_follow_up" label="Next Follow-up On">
                                <DatePicker
                                    size="large"
                                    format="DD-MM-YYYY"
                                    disabledDate={(current) =>
                                        current && current < dayjs().startOf("day")
                                    }

                                    onChange={(date) => {
                                        if (date) {
                                            const formattedForDB = dayjs(date).format("YYYY-MM-DD");
                                            console.log("Send this to DB:", formattedForDB);

                                            setFollowDate(formattedForDB);
                                        } else {
                                            setFollowDate(null);
                                        }
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>

                        </Col>
                    </Row>

                </Form>
            </Card>

            <Card
                style={{ marginTop: '10px', maxHeight: '370px' }}>
                <ListEqData data={eqData} handleGetCustomerData={handleGetCustomerData} form={customerForm} />
            </Card>

            <Card
                style={{ marginTop: '10px' }}>
                <AddQuotationData
                    followDate={followDate}
                    customerForm={customerForm}
                    Eqslected={Eqslected}
                    data={qu_gen}
                    selectedDate={selectedDate}
                    eqData={eqData}
                />
            </Card>

        </>
    );
};

export default CreateQuotation;
